import { render, staticRenderFns } from "./quiz-calculator.vue?vue&type=template&id=2c9bfc5a"
import script from "./quiz-calculator.vue?vue&type=script&lang=js"
export * from "./quiz-calculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports